// ─── Authentication Types ───

/**
 * User roles matching backend authorization (legacy app registration roles)
 */
export enum AuthRole {
  Supervisor = 'Supervisor',
  Analyst = 'Analyst',
  CustomerViewer = 'CustomerViewer',
}

/**
 * Application roles based on Azure AD security group membership.
 * These are determined by the user's security group memberships.
 */
export enum AppRole {
  /** Regular SOC operators - can take ownership of incidents */
  Operator = 'Operator',
  /** SOC administrators - can assign ownership and take ownership */
  Admin = 'Admin',
}

/**
 * Security group configuration for role mapping.
 * Group IDs should be configured via environment variables.
 */
export interface SecurityGroupConfig {
  /** Azure AD Object ID for soc-operators-asg security group */
  operatorsGroupId: string;
  /** Azure AD Object ID for soc-admin-asg security group */
  adminGroupId: string;
}

/**
 * Authenticated user information from Entra ID
 */
export interface AuthUser {
  /** Entra ID object ID */
  id: string;
  /** User display name */
  displayName: string;
  /** User email / UPN */
  email: string;
  /** User roles from app registration */
  roles: AuthRole[];
  /** Application roles derived from security group membership */
  appRoles: AppRole[];
  /** Security group IDs the user is a member of */
  groupIds: string[];
  /** Customer IDs user has access to (for Analyst/CustomerViewer) */
  assignedCustomerIds: string[];
}

/**
 * Authentication state
 */
export interface AuthState {
  /** Whether authentication is in progress */
  isLoading: boolean;
  /** Whether user is authenticated */
  isAuthenticated: boolean;
  /** Authenticated user info, null if not authenticated */
  user: AuthUser | null;
  /** Authentication error message */
  error: string | null;
}

/**
 * MSAL configuration for the application
 */
export interface MsalConfig {
  /** Azure AD app registration client ID */
  clientId: string;
  /** Azure AD tenant ID */
  tenantId: string;
  /** Redirect URI after login */
  redirectUri: string;
  /** API scope for backend access */
  apiScope: string;
}
